import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { REJECT_SLOT, REJECT_SLOT_ERROR, REJECT_SLOT_SUCCESS } from '../../../actions.js';

function* rejectSlot({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/vendor/reject-slot`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
      data: {
        ...payload?.data,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: REJECT_SLOT_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: REJECT_SLOT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: REJECT_SLOT_ERROR, payload: error });
  }
}

export function* watchrejectSlot() {
  yield takeEvery(REJECT_SLOT, rejectSlot);
}

function* rejectSlotSaga() {
  yield all([fork(watchrejectSlot)]);
}

export default rejectSlotSaga;
